import React, { Component } from "react";
import axios from "axios";
import { v4 as uuid } from "uuid";
const config = require("../config.json");
import Notification from "./Notification";

export default class NotificationAdmin extends Component {
  constructor(props) {
    super(props);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleNotificationInputChange =
      this.handleNotificationInputChange.bind(this);
  }

  state = {
    newNotification: {
      id: uuid(),
      notificationName: "",
      notificationTitle_da: "",
      notificationTitle_en: "",
      notificationMessage_da: "",
      notificationMessage_en: "",
      notificationImage: "",
      notificationLink: "",
      notificationLinkText_da: "",
      notificationLinkText_en: "",
    },
    title_da: "",
    title_en: "",
    message_da: "",
    message_en: "",
    link: "",
    linkText_da: "",
    linkText_en: "",
    image: "",
    testTitle: "",
    testMessage: "",
    testLink: "",
    testLinkText: "",
    testEmail: "",
    testImage: "",
    campaigns: [],
    notifications: [],
    notificationImages: [],
  };

  fetchNotificationImages = async () => {
    try {
      const res = await axios.get(
        `${config.api.invokeUrl}/images?bucketName=${config.s3.notificationImagesBucket}`
      );
      if (res.data?.Contents) {
        const notificationImages = res.data.Contents;
        this.setState({ notificationImages });
      }
    } catch (err) {
      console.log(err);
    }
  };

  sendNotification = async (event) => {
    event.preventDefault();
    if (window.confirm("Er du sikker?")) {
      try {
        const params = {
          title_da: this.state.title_da,
          title_en: this.state.title_en,
          message_da: this.state.message_da,
          message_en: this.state.message_en,
          link: this.state.link,
          linkText_da: this.state.linkText_da,
          linkText_en: this.state.linkText_en,
          image: this.state.image,
          campaignId: document.getElementById("campaigns")?.value,
        };

        await axios.post(`${config.api.invokeUrl}/notification/send`, params);
      } catch (err) {
        console.log(err);
      }
    }
  };

  sendSystemNotification = async (event) => {
    event.preventDefault();
    if (window.confirm("Er du sikker?")) {
      try {
        const params = {
          campaignId: document.getElementById("campaigns")?.value,
          notificationId: "",
        };

        await axios.post(
          `${config.api.invokeUrl}/notification/sendsystem`,
          params
        );
      } catch (err) {
        console.log(err);
      }
    }
  };

  onTitleChange = (event) => {
    this.setState({
      title: event.target.value,
    });
  };

  onMessageChange = (event) => {
    this.setState({
      message: event.target.value,
    });
  };

  sendTestNotification = async (event) => {
    event.preventDefault();
    if (window.confirm("Er du sikker?")) {
      try {
        const params = {
          title: this.state.testTitle,
          message: this.state.testMessage,
          link: this.state.testLink,
          linkText: this.state.testLinkText,
          email: this.state.testEmail,
          image: this.state.testImage,
        };
        await axios.post(`${config.api.invokeUrl}/notification/test`, params);
      } catch (err) {
        console.log(err);
      }
    }
  };

  fetchCampaigns = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/campaign/active`);
      const campaigns = res.data;
      this.setState({ campaigns: campaigns });
    } catch (err) {
      console.log(err);
    }
  };

  componentDidMount = async () => {
    this.fetchCampaigns();
    this.fetchNotifications();
    this.fetchNotificationImages();
  };

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      newNotification: {
        ...this.state.newNotification,
        [name]: value,
      },
    });
  }

  handleNotificationInputChange = (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  handleNotificationSelect = (event) => {
    const notificationId = event.target.value;

    if (!notificationId) {
      // Clear fields if empty option is selected
      this.setState({
        title_da: "",
        title_en: "",
        message_da: "",
        message_en: "",
        link: "",
        linkText_da: "",
        linkText_en: "",
        image: "",
      });
      return;
    }

    // Find the selected notification
    const selectedNotification = this.state.notifications.find(
      (notification) => notification.id === notificationId
    );

    if (selectedNotification) {
      // Populate the form fields with the selected notification's data
      this.setState({
        title_da: selectedNotification.notificationTitle_da || "",
        title_en: selectedNotification.notificationTitle_en || "",
        message_da: selectedNotification.notificationMessage_da || "",
        message_en: selectedNotification.notificationMessage_en || "",
        link: selectedNotification.notificationLink || "",
        linkText_da: selectedNotification.notificationLinkText_da || "",
        linkText_en: selectedNotification.notificationLinkText_en || "",
        image: selectedNotification.notificationImage || "",
      });
    }
  };

  fetchNotifications = async () => {
    try {
      const res = await axios.get(`${config.api.invokeUrl}/notification`);
      const notifications = res.data;
      this.setState({ notifications });
    } catch (err) {
      console.log(err);
    }
  };

  handleAddNotification = async (notification, event) => {
    event.preventDefault();
    try {
      const params = {
        id: notification.id,
        notificationName: notification.notificationName,
        notificationTitle_da: notification.notificationTitle_da,
        notificationTitle_en: notification.notificationTitle_en,
        notificationMessage_da: notification.notificationMessage_da,
        notificationMessage_en: notification.notificationMessage_en,
        notificationImage: notification.notificationImage,
        notificationLink: notification.notificationLink,
        notificationLinkText_da: notification.notificationLinkText_da,
        notificationLinkText_en: notification.notificationLinkText_en,
      };

      console.log(params);

      await axios.post(`${config.api.invokeUrl}/notification`, params);

      this.setState({
        notifications: [
          ...this.state.notifications,
          this.state.newNotification,
        ],
      });
      this.setState({
        newNotification: {
          id: uuid(),
          notificationName: "",
          notificationTitle_da: "",
          notificationTitle_en: "",
          notificationMessage_da: "",
          notificationMessage_en: "",
          notificationImage: "",
          notificationLink: "",
          notificationLinkText_da: "",
          notificationLinkText_en: "",
        },
      });
    } catch (err) {
      console.log(err);
    }
  };

  handleUpdateNotification = async (notification) => {
    try {
      const params = {
        id: notification.id,
        notificationName: notification.notificationName,
        notificationTitle_da: notification.notificationTitle_da,
        notificationTitle_en: notification.notificationTitle_en,
        notificationMessage_da: notification.notificationMessage_da,
        notificationMessage_en: notification.notificationMessage_en,
        notificationImage: notification.notificationImage,
        notificationLink: notification.notificationLink,
        notificationLinkText_da: notification.notificationLinkText_da,
        notificationLinkText_en: notification.notificationLinkText_en,
      };

      await axios.patch(
        `${config.api.invokeUrl}/notification/${notification.id}`,
        params
      );
    } catch (err) {
      console.log(err);
    }
    const updatedNotifications = [...this.state.notifications].filter(
      (c) => c.id !== notification.id
    );
    updatedNotifications.push(notification);
    this.setState({ notifications: updatedNotifications });
  };

  handleDeleteNotification = async (id, event) => {
    event.preventDefault();
    if (window.confirm("Er du sikker?")) {
      try {
        await axios.delete(`${config.api.invokeUrl}/notification/${id}`);
      } catch (err) {
        console.log(err);
      }
      const updatedNotifications = [...this.state.notifications].filter(
        (notification) => notification.id !== id
      );
      this.setState({ notifications: updatedNotifications });
    }
  };

  render() {
    return (
      <>
        <section className="section">
          <div className="container is-flex flex-wrap">
            <div className="column is-near-half">
              <p className="subtitle is-5">
                Send notifikationer til{"  "}
                <span style={{ color: "red", fontWeight: "bold" }}>
                  ALLE i kampagne
                </span>
              </p>
              Sender en notifikation til alle brugere i kampagnen
              <div className="field">
                <div className="control">
                  <select
                    className="select is-medium"
                    name="campaigns"
                    id="campaigns"
                    defaultValue=""
                  >
                    <option value="">-- Vælg en kampagne --</option>
                    {this.state.campaigns.map((campaign) => {
                      return (
                        <option key={campaign.id} value={campaign.id}>
                          {campaign.campaignName}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="control">
                  <label className="label">
                    Vælg eksisterende notifikation (valgfrit)
                  </label>
                  <select
                    className="select is-medium"
                    name="existingNotification"
                    onChange={this.handleNotificationSelect}
                    defaultValue=""
                  >
                    <option value="">-- Vælg en notifikation --</option>
                    {this.state.notifications.map((notification) => {
                      return (
                        <option key={notification.id} value={notification.id}>
                          {notification.notificationName}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="control">
                  <input
                    className="input is-medium"
                    type="text"
                    name="title_da"
                    placeholder="Indtast titel (DANSK)"
                    value={this.state.title_da}
                    onChange={this.handleNotificationInputChange}
                  />
                  <input
                    className="input is-medium"
                    type="text"
                    name="title_en"
                    placeholder="Indtast titel (ENGELSK)"
                    value={this.state.title_en}
                    onChange={this.handleNotificationInputChange}
                  />
                  <textarea
                    className="textarea"
                    name="message_da"
                    placeholder="Indtast besked (DANSK)"
                    value={this.state.message_da}
                    onChange={this.handleNotificationInputChange}
                  />
                  <textarea
                    className="textarea"
                    name="message_en"
                    placeholder="Indtast besked (ENGELSK)"
                    value={this.state.message_en}
                    onChange={this.handleNotificationInputChange}
                  />
                  <input
                    className="input is-medium"
                    type="text"
                    name="link"
                    placeholder="Indtast link"
                    value={this.state.link}
                    onChange={this.handleNotificationInputChange}
                  />
                  <input
                    className="input is-medium"
                    type="text"
                    name="linkText_da"
                    placeholder="Indtast link tekst (DANSK)"
                    value={this.state.linkText_da}
                    onChange={this.handleNotificationInputChange}
                  />
                  <input
                    className="input is-medium"
                    type="text"
                    name="linkText_en"
                    placeholder="Indtast link tekst (ENGELSK)"
                    value={this.state.linkText_en}
                    onChange={this.handleNotificationInputChange}
                  />
                  <select
                    className="select is-medium"
                    name="image"
                    id="image"
                    value={this.state.image}
                    defaultValue=""
                    onChange={this.handleNotificationInputChange}
                  >
                    <option value="">-- Vælg et billede --</option>
                    {this.state.notificationImages.map((image) => {
                      return (
                        <option key={image.Key} value={image.Key}>
                          {image.Key}
                        </option>
                      );
                    })}
                  </select>
                  {this.state.image && (
                    <div style={{ marginTop: "10px" }}>
                      <img
                        src={`${config.s3.notificationImagesUrl}${this.state.image}`}
                        alt="Selected notification"
                        style={{
                          maxWidth: "200px",
                          maxHeight: "200px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="control">
                  <button
                    type="submit"
                    className="button is-primary is-medium"
                    onClick={this.sendNotification}
                  >
                    Send
                  </button>
                  <button
                    type="submit"
                    className="button is-primary is-medium mh-small"
                    onClick={this.sendSystemNotification}
                  >
                    Send system notif
                  </button>
                </div>
                <div className="control"></div>
              </div>
            </div>
            <br />

            <div className="column is-near-half">
              <p className="subtitle is-5">Send TEST notifikation</p>
              Sender en notifikation til en bruger baseret på email
              <div className="field">
                <div className="control">
                  <input
                    className="input is-medium"
                    name="testEmail"
                    type="text"
                    placeholder="Indtast modtager email"
                    value={this.state.testEmail}
                    onChange={this.handleNotificationInputChange}
                  />
                  <input
                    className="input is-medium"
                    type="text"
                    name="testTitle"
                    placeholder="Indtast titel"
                    value={this.state.testTitle}
                    onChange={this.handleNotificationInputChange}
                  />
                  <textarea
                    className="textarea"
                    name="testMessage"
                    placeholder="Indtast besked"
                    value={this.state.testMessage}
                    onChange={this.handleNotificationInputChange}
                  />
                  <input
                    className="input is-medium"
                    name="testLink"
                    type="text"
                    placeholder="Indtast link"
                    value={this.state.testLink}
                    onChange={this.handleNotificationInputChange}
                  />
                  <input
                    className="input is-medium"
                    name="testLinkText"
                    type="text"
                    placeholder="Indtast link text"
                    value={this.state.testLinkText}
                    onChange={this.handleNotificationInputChange}
                  />

                  <select
                    className="select is-medium"
                    name="testImage"
                    id="testImage"
                    value={this.state.testImage}
                    defaultValue=""
                    onChange={this.handleNotificationInputChange}
                  >
                    <option value="">-- Vælg et billede --</option>
                    {this.state.notificationImages.map((image) => {
                      return (
                        <option key={image.Key} value={image.Key}>
                          {image.Key}
                        </option>
                      );
                    })}
                  </select>
                  {this.state.testImage && (
                    <div style={{ marginTop: "10px" }}>
                      <img
                        src={`${config.s3.notificationImagesUrl}${this.state.testImage}`}
                        alt="Selected test notification"
                        style={{
                          maxWidth: "200px",
                          maxHeight: "200px",
                          border: "1px solid #ccc",
                          borderRadius: "4px",
                        }}
                      />
                    </div>
                  )}
                </div>
                <div className="control">
                  <button
                    type="submit"
                    className="button is-primary is-medium"
                    onClick={this.sendTestNotification}
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="section">
          {" "}
          <div className="container">
            <p className="subtitle is-5">Tilføj og fjern notifikationer</p>
            <br />
            <div className="columns is-multiline">
              <div className="column is-full">
                <form
                  onSubmit={(event) =>
                    this.handleAddNotification(
                      this.state.newNotification,
                      event
                    )
                  }
                >
                  <div className="field">
                    <div className="control">
                      <input
                        className="input is-medium"
                        name={"notificationName"}
                        type="text"
                        placeholder="Indtast navn"
                        value={this.state.newNotification.notificationName}
                        onChange={this.handleInputChange}
                      />
                      <input
                        className="input is-medium"
                        name={"notificationTitle_da"}
                        type="text"
                        placeholder="Indtast titel (DANSK)"
                        value={this.state.newNotification.notificationTitle_da}
                        onChange={this.handleInputChange}
                      />
                      <input
                        className="input is-medium"
                        name={"notificationTitle_en"}
                        type="text"
                        placeholder="Indtast titel (ENGELSK)"
                        value={this.state.newNotification.notificationTitle_en}
                        onChange={this.handleInputChange}
                      />

                      <textarea
                        className="textarea"
                        placeholder="Indtast besked (DANSK)"
                        name="notificationMessage_da"
                        value={
                          this.state.newNotification.notificationMessage_da
                        }
                        onChange={this.handleInputChange}
                      />
                      <textarea
                        className="textarea"
                        placeholder="Indtast besked (ENGELSK)"
                        name="notificationMessage_en"
                        value={
                          this.state.newNotification.notificationMessage_en
                        }
                        onChange={this.handleInputChange}
                      />
                      <input
                        className="input is-medium"
                        name="notificationLink"
                        type="text"
                        placeholder="Indtast link URL"
                        value={this.state.newNotification.notificationLink}
                        onChange={this.handleInputChange}
                      />
                      <input
                        className="input is-medium"
                        name="notificationLinkText_da"
                        type="text"
                        placeholder="Indtast link tekst (DANSK)"
                        value={
                          this.state.newNotification.notificationLinkText_da
                        }
                        onChange={this.handleInputChange}
                      />
                      <input
                        className="input is-medium"
                        name="notificationLinkText_en"
                        type="text"
                        placeholder="Indtast link tekst (ENGELSK)"
                        value={
                          this.state.newNotification.notificationLinkText_en
                        }
                        onChange={this.handleInputChange}
                      />
                    </div>
                    <div className="control">
                      Billede:{" "}
                      <select
                        className="select is-medium"
                        name="notificationImage"
                        defaultValue=""
                        value={this.state.newNotification.notificationImage}
                        onChange={this.handleInputChange}
                      >
                        <option value="">-- Vælg et billede --</option>
                        {this.state.notificationImages.map((image) => {
                          return (
                            <option key={image.Key} value={image.Key}>
                              {image.Key}
                            </option>
                          );
                        })}
                      </select>
                      {this.state.newNotification.notificationImage && (
                        <div style={{ marginTop: "10px" }}>
                          <img
                            src={`${config.s3.notificationImagesUrl}${this.state.newNotification.notificationImage}`}
                            alt="Selected notification"
                            style={{
                              maxWidth: "200px",
                              maxHeight: "200px",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                            }}
                          />
                        </div>
                      )}
                    </div>

                    <div className="control">
                      <button
                        type="submit"
                        className="button is-primary is-medium"
                      >
                        Tilføj
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div className="column">
                {this.state.notifications.map((notification) => {
                  return (
                    <Notification
                      key={notification.id}
                      notification={notification}
                      handleDeleteNotification={this.handleDeleteNotification}
                      handleUpdateNotification={this.handleUpdateNotification}
                      notificationImages={this.state.notificationImages}
                    />
                  );
                })}
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}
